import styled from 'styled-components';
import Button from '@sdk/components/primitives/Button';

const LinkIconButton = styled(Button)`
  display: flex;
  margin-right: 10px;
  justify-content: center;
  align-items: center;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }): string => theme.colors.hoverBrand};
  }
`;

export default LinkIconButton;
